import React from 'react';
import UploadItem from './UploadItem';
import { Collapse } from 'reactstrap';

const FOLDER_ICONS = {
  caret: {
    open: 'fa fa-caret-down',
    closed: 'fa fa-caret-right',
  },
  folder: {
    open: 'fa fa-folder-open',
    closed: 'fa fa-folder',
  },
};

export default class EpubFolder extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState() {
    return {
      open: true,
      caret: FOLDER_ICONS.caret.open,
      folder: FOLDER_ICONS.folder.open,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.files.length == 0 && this.props.files.length != prevProps.files.length) {
      this.setState(this.initialState());
    }
  }

  toggle = () => {
    this.setState({
      open: !this.state.open,
      caret: this.state.open ? FOLDER_ICONS.caret.closed : FOLDER_ICONS.caret.open,
      folder: this.state.open ? FOLDER_ICONS.folder.closed : FOLDER_ICONS.folder.open,
    });
  }

  render() {
    if (this.props.files.length === 0) {
      return null;
    }
    return (<div className="epub-group" key={this.props.name}>
      <h3>
        <i className={this.state.folder} style={{ minWidth: '2rem' }} />
        &nbsp;{this.props.name}
        <i className={`${this.state.caret} float-md-end`} onClick={this.toggle} />
      </h3>
      <Collapse
        isOpen={this.state.open}
      >
        <ul className="list-group">
          {this.props.files.map((file, index) =>
            (<UploadItem
              key={this.props.name + index.toString()}
              file={file}
              removeFile={() => this.props.removeFile(this.props.type, index)}
              processImages={false}
              cover={false}
              colSizes={[2, 8, 2]}
              canSetCover={false}
              changeCover={false}
            />),
          )}
        </ul>
      </Collapse>
    </div>);
  }
}
